<template>
  <headroom :class="{ change_color: scrollPosition > headerSectionHeight }">
    <nav class="navbar navbar-light" style="background-color: transparent">
      <div class="container nav-container">
        <b-navbar-brand :to="{ name: 'Root' }" class="navbar-brand">
          UNSTITCHED
        </b-navbar-brand>

        <form-horizontal
          text="Get started"
          :class="{ 'hidden-sm': scrollPosition < headerSectionHeight }"
        ></form-horizontal>
      </div>
    </nav>
  </headroom>
</template>

<script>
import FormHorizontal from "@/components/landing/FormHorizontal.vue";
import router from "@/router";
import { mapGetters } from "vuex";
import { bus } from "@/main";
import { headroom } from "vue-headroom";

export default {
  components: {
    headroom,
    FormHorizontal,
  },

  mounted() {
    window.addEventListener("scroll", this.updateScroll);

    if (
      this.$parent.$refs.headerSectionOuter &&
      this.$parent.$refs.headerSectionOuter.$refs.headerSection
    ) {
      this.headerSectionHeight =
        this.$parent.$refs.headerSectionOuter.$refs.headerSection.offsetHeight;
    }
  },

  destroy() {
    window.removeEventListener("scroll", this.updateScroll);
  },

  data() {
    return {
      scrollPosition: null,
      headerSectionHeight: null,
    };
  },

  computed: {
    ...mapGetters(["currentUser"]),

    divHeight() {
      if (
        this.$parent.$refs.headerSectionOuter &&
        this.$parent.$refs.headerSectionOuter.$refs.headerSection
      ) {
        return this.$parent.$refs.headerSectionOuter.$refs.headerSection
          .offsetHeight;
      }
    },
  },

  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },

    clickOpenSignUpModal() {
      if (this.currentUser) {
        router.push({ name: "DiscoverCapsules" });
      } else {
        bus.$emit("openSignUpModal");
      }
    },
  },
};
</script>

<style lang="scss">
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.headroom {
  z-index: 999 !important;

  .nav-container {
    padding: 0;
  }

  .navbar-brand {
    font-size: 32px;
    color: $primary-blue;
    font-family: "Lombok";

    @include for-sm-phone-only {
      font-size: 28px;
    }
  }

  @include for-sm-phone-only {
    .btn-sign-up-form {
      padding: 10px;
    }
  }
}

.change_color {
  background: #fafafa;
}

.hidden-sm {
  visibility: hidden;
  @include for-tablet-portrait-up {
    visibility: visible;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing/Navbar.vue